import { Injectable } from '@angular/core';
import 'rxjs/add/observable/of';
import { BaseService } from './base.service';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class UserService extends BaseService {

    public groupId = null;

    public getForms(): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/user/form/list', { headers: this.getHeader() });
    }

    public getFormFields(): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/user/form/listAll', { headers: this.getHeader() });
    }


    public getUserData(idUser: number = null): Observable<any> {
        let query = "";
        if (this.groupId) query = "?group=" + this.groupId;
        if (idUser !== null) {
            return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/' + idUser, { headers: this.getHeader() });
        }
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user' + query, { headers: this.getHeader() });
    }

    public getAllUserData(filter = null, regional = false): Observable<any> {
        let query = "?all";
        if (filter) {
            if (typeof filter == "string") {
                if (filter != "") {
                    query += '&search=' + filter;
                }
            }
            else {
                if (filter.id) {
                    query += '&id=' + filter.id;
                }
            }
        }

        if (regional) {
            query += "&regional=true";
        }

        if (this.groupId) query = "&group=" + this.groupId;
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user' + query, { headers: this.getHeader() });
    }

    public getUserPagination(page: number): Observable<any> {
        let query = "";
        if (this.groupId) query = "&group=" + this.groupId;
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user?page=' + page + query, { headers: this.getHeader() });
    }

    public getUserSearch(term: string): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/search?' + term, { headers: this.getHeader() });
    }

    public getUserSearchPaginate(term: string, page: any = 1,): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/search?search=' + term + '&page=' + page, { headers: this.getHeader() });
    }

    public getUserByGroupSearchPaginate(term: string, group, page: any = 1): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/search?search=' + term + '&page=' + page + '&group=' + group, { headers: this.getHeader() });
    }

    public getUserForm(): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/user/form', { headers: this.getHeader() });
    }

    public getAdressByCep(cep: string): Observable<any> {
        const headerOptions = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };
        return this.http.get('http://viacep.com.br/ws/' + cep + '/json/', { headers: new HttpHeaders(headerOptions) });
    }

    public remove(id): Observable<any> {
        const url = this.baseUrl + '/api/v2/admin/user/delete/' + id;
        return this.http.delete(url, { headers: this.getHeader() });
    }

    public saveData(data: any, idCliente = null, sendwelcomeEmail = false): Observable<any> {
        const headerOptions = {
            'Authorization': sessionStorage.getItem('token'),
            'Accept': 'application/json'
        };
        if (idCliente === null) {
            return this.http.post(this.baseUrl + '/api/v2/admin/asap-user/store?send_welcome_email=' + sendwelcomeEmail,
                data,
                { headers: new HttpHeaders(headerOptions) });
        }
        return this.http.put(this.baseUrl + '/api/v2/admin/asap-user/' + idCliente + '/update',
            data,
            { headers: new HttpHeaders(headerOptions) });
    }

    public putData(data: any, idCliente = null): Observable<any> {
        const headerOptions = {
            'Authorization': sessionStorage.getItem('token'),
            'Accept': 'application/json'
        };
        return this.http.put(this.baseUrl + '/api/v2/admin/permission/' + idCliente + '/update',
            data,
            { headers: new HttpHeaders(headerOptions) });
    }

    public putSubData(data: any, idCliente = null): Observable<any> {
        const headerOptions = {
            'Authorization': sessionStorage.getItem('token'),
            'Accept': 'application/json'
        };
        return this.http.put(this.baseUrl + '/api/v2/admin/permission/' + idCliente + '/sub/update',
            data,
            { headers: new HttpHeaders(headerOptions) });
    }

    public getPermData(idCliente = null, param): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/permission/module/' + idCliente + '?modulo=' + param, { headers: this.getHeader() });
    }

    public postPermData(data: any, idCliente = null, param): Observable<any> {
        const headerOptions = {
            'Authorization': sessionStorage.getItem('token'),
            'Accept': 'application/json'
        };
        return this.http.post(
            this.baseUrl + '/api/v2/admin/asap-user/permission/module/' + idCliente + '?modulo=' + param,
            data,
            { headers: new HttpHeaders(headerOptions) }
        );
    }

    public getUser(id) {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/dados/' + id, { headers: this.getHeader() });
    }

    public getUsers() {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/list/users', { headers: this.getHeader() });
    }

    public getUserPermission(id) {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/list/permission/' + id, { headers: this.getHeader() });
    }


    ///api/v2/admin/folder/permission/list/21?type=jornadas-folder&client_id=108
    //api.tecnologiaasap.com.br/api/v2/admin/folder/permission/497?client_id=108

    public saveUsers(id, target_type, user_id) {
        return this.http.post(this.baseUrl + '/api/v2/admin/folder/permission/' + id, { field: 'user_id', target_type, value: user_id }, { headers: this.getHeader('application/json') });
    }

    public getUsersPermission(id, type) {
        return this.http.get(this.baseUrl + `/api/v2/admin/folder/permission/list/${id}?type=${type}`, { headers: this.getHeader('application/json') });
    }

    public getPermission() {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/list/permission', { headers: this.getHeader() });
    }

    public deleteUserPermission(id) {
        return this.http.delete(this.baseUrl + '/api/v2/admin/permission/' + id, { headers: this.getHeader() });
    }

    public deleteUserListPermission(id) {
        return this.http.delete(this.baseUrl + `/api/v2/admin/folder/permission/list/` + id, { headers: this.getHeader() })
    }

    public permissionBI(action, userID, bi = null) {
        let data: any = {
            action: action,
            user_id: userID,
            bi: bi
        };
        return this.http.post(this.baseUrl + '/api/v2/admin/permission/bi', data, { headers: this.getHeader('application/json') });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts